module.exports = __webpack_public_path__ + "img/20220422123408712nff.41be2b4f.png";